import pako from 'pako';
import { sendWebsocketMessage } from '../../../../../../App';

export async function updateCurrentLayout(type, name, json) {
  const msg = {
    messageType: 'updateCurrentLayout',
    type,
    name,
    json,
  };
  const stringifiedMsg = JSON.stringify(msg);
  if (new Blob([stringifiedMsg]).size > 7500) {
    const compressed = pako.gzip(stringifiedMsg);
    sendWebsocketMessage(compressed);
  } else {
    sendWebsocketMessage(msg);
  }
}
